import { DEFAULT_ACTIVE_BRANCH_ID } from '../constants/constants';
import { serializeAsQueryString } from './utils';

export const constructPageString = ({ page, sortBy }) => {
  const pageString = serializeAsQueryString(
    {
      page: page.number,
      size: page.size
    },
    true
  );

  const hasSort = !!sortBy && !!sortBy.name && !!sortBy.direction;
  const sortString = hasSort ? `sort=${sortBy.name},${sortBy.direction}` : '';

  return `${pageString}&${sortString}`;
};

export const getBranchIds = (branchId, branches) =>
  branchId === DEFAULT_ACTIVE_BRANCH_ID
    ? branches.map(branch => branch.branchId)
    : [branchId];

export const getBranchRouteNumbers = (branchRouteNumber, routes) =>
  !!branchRouteNumber
      ? [branchRouteNumber]
      : routes.map(route => `${route.branchId}:${route.routeNumber}`);
